module.exports = __webpack_public_path__ + "img/registrationSchemaChe.3cdb667a.svg";